import { useCookie, useRuntimeConfig } from "#imports";
import { COOKIE_SHOW_DEFAULT_TRANSLATIONS } from "../constants.js";
export function useShowDefaultMessage() {
  const config = useRuntimeConfig().public.i18n;
  if (config.showDefaultMessage) return true;
  const showDefaultMessageFromCookie = Boolean(
    useCookie(COOKIE_SHOW_DEFAULT_TRANSLATIONS).value
  );
  return showDefaultMessageFromCookie;
}
